import "#legacy/shared/sparkle_namespace.js";
import { transferInputOwnership } from "#/admin/legacy/forms/input-ownership.js";

// Sparkle.DateField replaces a `[data-behaviour~=datepicker]` input with an `<sp-date-field>`
// carrying the input's name, value, id and class, so the label, the form and any script addressing
// it by id still reach it.
Sparkle.DateField = {
  replace: function (input) {
    if (input.dataset.alreadyDecorated) {
      return null;
    }

    input.dataset.alreadyDecorated = true;

    var options = this.optionsFor(input);
    var field = document.createElement("sp-date-field");

    field.setAttribute("value", input.value);
    if (input.name) {
      field.setAttribute("name", input.name);
    }
    if (input.id) {
      field.setAttribute("id", input.id);
    }
    if (input.className) {
      field.setAttribute("class", input.className);
    }
    if (input.placeholder) {
      field.setAttribute("placeholder", input.placeholder);
    }
    if (input.disabled) {
      field.setAttribute("disabled", "");
    }
    if (input.required) {
      field.setAttribute("required", "");
    }

    var ariaLabel = input.dataset.ariaLabel || input.getAttribute("aria-label");
    if (ariaLabel) {
      field.setAttribute("aria-label", ariaLabel);
    }

    if (options.enableTime) {
      field.setAttribute("enable-time", "");
    }
    field.setAttribute("display-format", options.displayFormat);
    if (options.valueFormat) {
      field.setAttribute("value-format", options.valueFormat);
    }

    // A typable field carries a clear control, and shows it whenever it holds a value rather than
    // only under the pointer.
    if (options.allowInput) {
      field.setAttribute("allow-input", "");
      field.setAttribute("clearable", "");
      field.setAttribute("persistent-clear", "");
    }

    Object.keys(input.dataset).forEach(function (key) {
      if (key === "flatpickrOptions") {
        return;
      }

      field.dataset[key] = input.dataset[key];
    });

    transferInputOwnership(input, field);
    input.replaceWith(field);

    return field;
  },

  replaceAll: function (container) {
    var me = this;

    jQuery(container || document)
      .find("[data-behaviour~=datepicker]:not([data-already-decorated])")
      .each(function (index, element) {
        me.replace(element);
      });
  },

  // Returns the `sp-date-field` options for the input's `data-flatpickr-options`. flatpickr's
  // `dateFormat` is the value the form submits and `altFormat` the text the user reads. `altInput`
  // defaults on, so an input configuring no `altFormat` reads as m/d/Y.
  optionsFor: function (input) {
    var configured = {};

    try {
      configured = JSON.parse(input.dataset.flatpickrOptions || "{}");
    } catch (error) {
      configured = {};
    }

    var enableTime = !!configured.enableTime;
    var valueFormat = configured.dateFormat || (enableTime ? "Y-m-d H:i" : "Y-m-d");

    return {
      enableTime: enableTime,
      allowInput: !!configured.allowInput,
      valueFormat: configured.dateFormat,
      displayFormat: configured.altInput === false ? valueFormat : configured.altFormat || "m/d/Y",
    };
  },
};
